import { ref } from '@vue/composition-api'

export default refs => Object.fromEntries(
  refs.map(_ => [
    _,
    ref(null)
  ])
)
